import React, { useState, useEffect } from 'react';
import { useAuth } from '../Context/authContext';
import { TextField, Button, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper, IconButton, } from '@mui/material';
import DeleteIcon from '@mui/icons-material/Delete';
import { addDoc, collection, getDocs, deleteDoc ,doc} from "firebase/firestore";
import { db2 } from '../firebase';
import "./Novedades.style.css";

const Novedades = () => {
  const { user } = useAuth();
  const [novedades, setNovedades] = useState([]);
  const [fecha, setFecha] = useState('');
  const [nuevaNovedadText, setNuevaNovedadText] = useState('');

  // Función para obtener los datos de la colección 'novedades'
  const getDataNote = async () => {
    const querySnapshot = await getDocs(collection(db2, "novedades"));
    const novedadesData = querySnapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
    setNovedades(novedadesData);
  };

  const addNovedad = async () => {
    // Verificar si la fecha está definida, si no, usar la fecha actual
    const fechaActual = new Date();
    const fechaFormateada = fecha ? formatDate(fecha) : formatDate(fechaActual);
  
    const nuevaNovedad = {
      fecha: fechaFormateada, // Usar la fecha formateada
      novedad: nuevaNovedadText || "Nueva novedad" // Usar el texto ingresado o "Nueva novedad" si está vacío
    };
  
    try {
      await addDoc(collection(db2, "novedades"), nuevaNovedad);
      getDataNote(); // Actualizar los datos después de agregar una nueva entrada
      setNuevaNovedadText(''); // Limpiar el texto después de agregar la novedad
    } catch (e) {
      console.error("Error adding document: ", e);
    }
  };
  
  // Función para borrar una novedad
const deleteNovedad = async (id) => {
  try {
    await deleteDoc(doc(db2, 'novedades', id));
    getDataNote(); // Actualizar los datos después de eliminar una entrada
  } catch (error) {
    console.error("Error deleting document: ", error);
  }
};


  // Función para formatear la fecha en el formato día/mes/año
  const formatDate = (dateString) => {
    // Crear un objeto de fecha a partir de la cadena
    const dateObj = new Date(dateString);
    
    // Obtener los componentes de la fecha
    const day = String(dateObj.getUTCDate()).padStart(2, '0');
    const month = String(dateObj.getUTCMonth() + 1).padStart(2, '0');
    const year = dateObj.getUTCFullYear();

    // Formatear la fecha
    return `${day}/${month}/${year}`;
  };

  // Obtener los datos al cargar el componente
  useEffect(() => {
    getDataNote();
  }, []);

  return (
    <div>
      <h1>Novedades</h1>
      {
        // Si el usuario existe, mostrar el formulario para agregar una nueva novedad
        user &&
        <div className="Novedades__div--filters">
          <input
            type="date"
            style={{
              border: "1px solid #ccc",
              borderRadius: "5px",
              padding: "8px",
              width: "220px",
              height: "60px",
              boxSizing: "border-box",
              fontSize: "20px" 
            }}
            onChange={(e) => setFecha(e.target.value)}
          />
          <TextField
            id="outlined-multiline-static"
            label="Escribe tu novedad aquí"
            multiline
            rows={4}
            value={nuevaNovedadText}
            onChange={(e) => setNuevaNovedadText(e.target.value)}
          />
          <Button
            variant="contained"
            sx={{ background: "#333333", ":hover": { background: "#333333" } }}
            onClick={addNovedad}
          >
            Agregar Novedad
          </Button>
        </div>
      }
      {/* Mostrar la tabla con las novedades */}
      <TableContainer component={Paper} style={{ marginTop: "1em",maxHeight: "700px", overflowY: "auto" }}>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell>Fecha</TableCell>
              <TableCell>Novedad</TableCell>
              {user && <TableCell>Acciones</TableCell>}
            </TableRow>
          </TableHead>
          <TableBody >
            {novedades.map((novedad) => (
              <TableRow key={novedad.id}>
                <TableCell>{novedad.fecha}</TableCell>
                <TableCell>{novedad.novedad}</TableCell>
                {user && (
                  <TableCell>
                    <IconButton onClick={() => deleteNovedad(novedad.id)}>
                      <DeleteIcon />
                    </IconButton>
                  </TableCell>
                )}
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </div>
  );
}

export default Novedades;
